import { createTypedApiClient } from '@orborix/auth-client';
import type {
  LexiconReportContext,
  LexiconReportInput,
  OwnLexiconReport,
} from '@orborix/shared-types';
const client = createTypedApiClient({
  basePath: '/api/modules/english',
  errorName: 'LexiconReportApiError',
  abortError: 'wrap',
});
export const LexiconReportApiError = client.ApiError;
export async function reportContext(word: string): Promise<LexiconReportContext> {
  const res = await client.request('/lexicon/reports/context?' + new URLSearchParams({ word }).toString());
  await client.ensureOk(res);
  return res.json() as Promise<LexiconReportContext>;
}
export async function sendLexiconReport(input: LexiconReportInput): Promise<OwnLexiconReport> {
  const res = await client.request('/lexicon/reports', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
  await client.ensureOk(res);
  return ((await res.json()) as { report: OwnLexiconReport }).report;
}
export async function restoreMeaning(word: string, meaningId: string): Promise<void> {
  const res = await client.request('/lexicon/reports/restore', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ word, meaningId }),
  });
  await client.ensureOk(res);
}
